(function () {
    'use strict';

    // @ngInject
    function TitleSecondLevelNavigationControllerCtor($scope, $injector, $state) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'TitleSecondLevelNavigationController';

        this.$state = $state;
        this.title = this.$state.$current.data.title;
    }

    Controllers.TitleSecondLevelNavigationController = Class(Controllers.BaseController, {
        constructor: TitleSecondLevelNavigationControllerCtor
    });
}());
